import { DEFAULT_LOCALE, formatDate, isSupportedLocale, type DateStyle, type Locale } from "@financialharmony/i18n"

export interface Formatters {
  /** The language the formatters are bound to. */
  locale: Locale
  /** `formatDate` from `@financialharmony/i18n`, bound to `locale`. */
  formatDate: (value: Date | string | number, style?: DateStyle) => string
}

/**
 * `formatDate` bound to one language: the single place a locale becomes a formatter, shared by the
 * client hook (`useFormatters`) and the server one (`getFormatters` in apps/client). A value that
 * is not a supported language falls back to `DEFAULT_LOCALE`, the way `useUiLocale` does.
 */
export function createFormatters(locale: string): Formatters {
  const language = isSupportedLocale(locale) ? locale : DEFAULT_LOCALE
  return {
    locale: language,
    formatDate: (value, style) => formatDate(value, language, style),
  }
}
